/**
 * Photo rights attestation checkbox — the "I confirm I have the right to
 * share these images" gate that appears whenever a user is uploading new
 * photos on an item add flow. Renders nothing when there are no pending
 * photos so the checkbox doesn't sit around confusingly on an empty form.
 *
 * Positioned by the caller directly beneath the Photos section so the
 * attestation reads as paired with the upload (previous layout on
 * AddPolishModal put it at the bottom of the form near submit, which read
 * as an unrelated legalese footnote and users missed it).
 *
 * State is owned by the caller (single boolean) so the parent can gate
 * its submit button on it. Every itemType's Add modal wires this up
 * identically.
 */

interface Props {
  pendingCount: number;
  confirmed: boolean;
  onChange: (confirmed: boolean) => void;
}

export default function PhotoRightsAttestation({ pendingCount, confirmed, onChange }: Props) {
  if (pendingCount === 0) return null;
  return (
    <label className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-900 cursor-pointer">
      <input
        type="checkbox"
        checked={confirmed}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5"
      />
      <span>
        I confirm I have the right to share {pendingCount === 1 ? 'this image' : 'these images'}.{' '}
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
          onClick={(e) => e.stopPropagation()}
        >
          Terms
        </a>
      </span>
    </label>
  );
}
